/**
 * 支出账单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>本月支出</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <div class="block">
          <el-date-picker
            size="small"
            style="width: 240px"
            v-model="formInline.revenueDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item>
        <el-form-item label="" prop="transType">
          <el-select size="small" v-model="formInline.flowType" clearable placeholder="请选择类型">
            <el-option v-for="type in flowTypeEnum" :label="type.key" :value="type.value" :key="type.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" v-if="$canEntry()" @click="handleAdd()">增加支出</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="occurrenceTime" label="支出日期" width="150" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{scope.row.occurrenceTime|formatDate}}</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="type" label="支出类型" width="150" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{flowTypeFormate(scope.row.type)}}</span>
        </template>
      </el-table-column>
      <el-table-column sortable prop="roomNo" label="房间号（退押金）" width="150" show-overflow-tooltip :formatter="row => row.roomNo || '-'">
      </el-table-column>
      <el-table-column sortable prop="describe" label="类型描述" width="150" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="expenditureAmount" label="支出金额" width="150" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="notes" label="备注" width="150" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" v-if="$canManage()" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" v-if="$canManage()" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('editForm')">
      <el-form label-width="120px" :model="editForm" ref="editForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="支出类型">
              <el-select size="small" v-model="editForm.type" clearable placeholder="请选择类型">
                <el-option  v-for="type in flowTypeAddEnum" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="支出数额">
              <el-input size="small" :style="{ width: '182px' }" tabindex="2" v-model="editForm.expenditureAmount" auto-complete="off" placeholder="请输入支出数额"></el-input>
            </el-form-item>
            <el-form-item label="日期">
              <div class="block" >
                <el-date-picker
                  size="small"
                  style="width: 180px"
                  v-model="editForm.occurrenceTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="类型描述">
              <el-input size="small" :style="{ width: '182px' }" tabindex="1" v-model="editForm.describe" auto-complete="off" placeholder="请输入类型描述"></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input size="small"  :style="{ width: '182px' }" tabindex="3" v-model="editForm.notes" auto-complete="off" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import {addOrUpdateExpenditureFlow, deleteExpenditureFlow, queryExpenditureFlowPage} from "../../api/realTimeBill";
import {formatDate} from '../../utils/util'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '预览',
      flowTypeEnum:[
        { key: '请选择', value: null},
        { key: '退押金', value: 1},
        { key: '预存', value: 2},
        { key: '材料费', value: 3},
        { key: '服务费', value: 4},
        { key: '工资', value: 5},
        { key: '分红', value: 6}
      ],
      // "增加支出"弹窗里不给选"退押金"/"分红"：退押金只能由退房流程自动生成，
      // 分红要走"股东分红"页面的发起分红，才能按股东拆分明细
      flowTypeAddEnum:[
        { key: '请选择', value: null},
        { key: '预存', value: 2},
        { key: '材料费', value: 3},
        { key: '服务费', value: 4},
        { key: '工资', value: 5}
      ],
      editForm: {
        id: '',
        type: '',
        describe: '',
        expenditureAmount: '',
        notes: '',
        occurrenceTime: '',
        token: localStorage.getItem('logintoken')
      },
      formInline: {
        current: 1,
        size: 10,
        revenueDate: null,
        flowType: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      // 模拟数据开始
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      queryExpenditureFlowPage(parameter)
        .then(res => {
          this.loading = false
          if (res.code !== '200') {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data.content
            // 分页赋值
            this.pageparm.currentPage = this.formInline.current
            this.pageparm.pageSize = this.formInline.size
            this.pageparm.total = res.data.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('本月入账加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.current = parm.currentPage
      this.formInline.size = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.current = 1
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      this.title='修改支出'
      this.editForm.id=row.id;
      this.editForm.type=row.type;
      this.editForm.describe=row.describe;
      this.editForm.notes=row.notes
      this.editForm.expenditureAmount=row.expenditureAmount
      this.editForm.occurrenceTime=formatDate(row.occurrenceTime)
    },// 显示添加支出
    handleAdd(){
      this.editFormVisible = true
      this.title='添加支出'
      this.editForm.id=''
      this.editForm.type=''
      this.editForm.describe=''
      this.editForm.notes=''
      this.editForm.expenditureAmount=''
      this.editForm.occurrenceTime=formatDate(new Date())
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          addOrUpdateExpenditureFlow(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code==='200') {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '支出流水处理成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('支出流水处理失败！')
            })
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteExpenditureFlow([row.id])
            .then(res => {
              if (res.code==='200') {
                this.$message({
                  type: 'success',
                  message: '删除支出流水成功!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('支出流水删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    },
    flowTypeFormate(itemValue){
      for(let obj of this.flowTypeEnum){
        if(obj.value===itemValue){
          return obj.key;
        }
      }
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>







// WEBPACK FOOTER //
// src/views/realTimeBill/expenseBill.vue